export default function determineSurvery(typeCard, deliveryType, debitDeliveryData, creditData, debitData) {
    const typeCards = {
        debitCardDelivery: debitDeliveryData,
        creditCard: creditData,
        debitCard: debitData,
    };

    const currentDataSurvery = typeCards[typeCard];

    const returnData = deliveryType === 'office' ? currentDataSurvery?.office : currentDataSurvery?.courier;
    const noEmptySuveryData = returnData?.points?.some(point => !!point?.value && !!point?.successHeader);

    return noEmptySuveryData ? returnData : null;
}
